// extracted by mini-css-extract-plugin
export default {"mainBox":"notFound-module--mainBox--eaAFd","titleImg":"notFound-module--titleImg--tMO03"};